<template>
  <div class="page-personal">
    <header-top></header-top>
    <!-- <div class="header-title">{{headerText}}</div> -->
    <div class="wrap">
      <!-- 基本信息 -->
      <div class="content">
        <div class="essential flex">
          <div class="essential-item">
            <div class="details-name">
              <img v-if="userInfo.photoUrl" :src="userInfo.photoUrl" alt="" />
              <img v-else src="@/assets/image/follow-header.png" alt="" />
              <div>
                <div class="name">Hi，{{ userInfo.name }}</div>
                <div class="org">{{ userInfo.organizationUnit }}</div>
              </div>
            </div>
            <div class="details-post">
              <div class="line"></div>
              <div class="post">
                <div class="tit">职务</div>
                <div>{{ userInfo.post }}</div>
              </div>
            </div>
            <div class="details-position">
              <div class="line"></div>
              <div class="post">
                <div class="tit">职责</div>
                <div>{{ userInfo.position }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="essential-item essential-left">
            <div class="flex essential-item-box">
              <div class="key">姓名</div>
              <div class="flex">
                <div>{{userInfo.name||''}}</div>
                <div class="tag" v-if="userInfo.position">{{userInfo.position||''}}</div>
              </div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">账号ID</div>
              <div>{{userInfo.emId|nullValue}}</div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">实际工龄</div>
              <div>
                <span>{{userInfo.cumulativeWorkingTime|nullValue}}</span>
                <span v-if="userInfo.firstWorkTime">（{{userInfo.firstWorkTime|dateFormatChinese}}入职）</span>
              </div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">个人签名</div>
              <div>
                <span>{{userInfo.motto|nullValue}}</span>
                <span @click="editMottoShow">
                  <svg-icon icon-class="edit" class="icon-edit" />
                </span>
              </div>
            </div>
          </div>
          <div class="essential-item essential-right">
            <div class="flex essential-item-box">
              <div class="key">认证状态</div>
              <div class="flex">
                <div class="authentication">
                  <svg-icon class="authentication-icon" icon-class="success" />已认证
                </div>
                <div
                  class="edit-auth"
                  @click="$router.push({path:'/personal/authentication'})"
                >查看或修改认证</div>
              </div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">主岗位</div>
              <div>{{headPost}}</div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">联系手机</div>
              <div>
                <span v-if="hidePhoneNumber">+86 {{hidePhoneNumber}}</span>
                <span v-else>无</span>
                <span @click="isEditPhoneShow = !isEditPhoneShow">
                  <svg-icon icon-class="edit" class="icon-edit" />
                </span>
              </div>
            </div>
            <div class="flex essential-item-box">
              <div class="key">联系邮箱</div>
              <div>
                <span v-if="userInfo.email">{{userInfo.email}}</span>
                <span v-else>无</span>
                <span @click="isEditEmailShow = !isEditEmailShow">
                  <svg-icon icon-class="edit" class="icon-edit" />
                </span>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="login">
        <div class="title">登录账号</div>
        <div class="login-box">
          <div class="phone">
            手机号<span class="phone-info">{{ hidePhoneNumber }}</span
            ><span
              class="update-phone"
              @click="isEditPhoneShow = !isEditPhoneShow"
              >修改手机号</span
            >
          </div>
          <div class="phone">
            微信号<span class="phone-info">{{
              userInfo.wechat | nullValue
            }}</span>
          </div>
        </div>
      </div>
      <div class="contact-info">
        <div class="title">联系方式</div>
        <div class="contact-tit">
          <div>联系方式</div>
          <div class="center">详细信息</div>
          <div>操作</div>
        </div>
        <div class="contact-list">
          <div>手机号</div>
          <div class="center">{{ hidePhoneNumber }}</div>
          <div @click="isEditPhoneShow = !isEditPhoneShow" class="operation">
            修改
          </div>
        </div>
        <div class="contact-list">
          <div>邮箱</div>
          <div class="center">{{ userInfo.email | nullValue }}</div>
          <div @click="isEditEmailShow = !isEditEmailShow" class="operation">
            修改
          </div>
        </div>
        <!-- <div class="contact-list">
          <div>微信</div>
          <div class="center">{{userInfo.wechat|nullValue}}</div>
          <div  @click="isAuthenticationShow = !isAuthenticationShow" class="operation">修改</div>
        </div> -->
      </div>
      <div class="password">
        <div class="title">密码设置</div>
        <el-form
          :rules="editPswRules"
          ref="editPswQuery"
          :model="editPswQuery"
          label-width="6rem"
          label-position="left"
        > 
        <el-form-item label="账户">
          <div class="name">
              {{userInfo.organizationUnit}} - {{userInfo.name}}
              </div>
            </el-form-item>
            <el-form-item label="原始密码" prop="currentPassword">
              <el-input
                type="password"
                class="input-email"
                v-model="editPswQuery.currentPassword"
                placeholder="请输入原始密码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                type="password"
                class="input-email"
                v-model="editPswQuery.newPassword"
                placeholder="请输入新密码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="repetPsw">
              <el-input
                type="password"
                class="input-email"
                v-model="editPswQuery.repetPsw"
                placeholder="请再次输入新密码"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="验证码" prop="code">
            <div class="flex input-code-group">
              <el-input
                v-model="editPswQuery.code"
                placeholder="请输入手机验证码"
                class="input-code"
                clearable
              ></el-input>
              <div
                class="send flex-center"
                :class="{disabled:messageCodeText!='发送验证码'}"
                @click="messageCodeText=='发送验证码'?sendCode(userInfo.phoneNumber):''"
              >{{messageCodeText}}</div>
            </div>
          </el-form-item>-->
        </el-form>
          <span class="submit-ben">
            <el-button @click="closePassWord">取消</el-button>
            <el-button type="primary" @click="changePswSubmit('editPswQuery')"
              >确定</el-button
            >
          </span>
      </div>
      <!-- <div class="flex-between">
        <div class="login-type-group">
          <div class="content">
            <div class="content-title flex-between">
              <div>登录方式</div>
              <div class="right">帮助指引</div>
            </div>
            <div class="essential flex">
              <div class="essential-item essential-left login-type-left">
                <div class="flex essential-item-box">
                  <div class="key key-login">账号支持多种登录方式，便捷管理账号</div>
                </div>
                <div class="flex essential-item-box">
                  <div class="key">手机号</div>
                  <div class="flex">
                    <div class="authentication">{{hidePhoneNumber}}</div>
                    <div class="edit-auth" @click="isEditPswShow = !isEditPswShow">修改密码</div>
                  </div>
                </div>
                <div class="flex">
                  <div class="key">邮箱</div>
                  <div>
                    <div class="flex" v-if="userInfo.email">
                      <div class="authentication">{{userInfo.email}}</div>
                      <div class="edit-auth" @click="unbindEmail">解绑</div>
                    </div>
                    <div class="flex" v-else>
                      <div class="authentication">无</div>
                      <div class="edit-auth" @click="isEditEmailShow=true;">绑定</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="essential-item essential-right flex login-type-right">
                <div class="flex essential-item-box">
                  <div class="key">微信</div>
                  <div class="flex">
                    <div class="authentication">无</div>
                    <div class="edit-auth" @click="isAuthenticationShow = !isAuthenticationShow">绑定</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="account-access">
          <div class="content">
            <div class="content-title flex-between">
              <div>账号权限</div>
            </div>
            <div class="essential flex">
              <div class="essential-item essential-left account-access-left">
                <div class="flex essential-item-box">
                  <div class="key key-tip">账号支持多种登录方式，便捷管理账号</div>
                </div>
                <div class="flex essential-item-box">
                  <div class="key">账号身份</div>
                  <div>{{userInfo.name}}</div>
                </div>
                <div class="flex">
                  <div class="key">账号权限</div>
                  <div>{{userInfo.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 修改联系手机 -->
    <el-form
      v-if="isEditPhoneShow"
      :rules="editPhoneRules"
      ref="editPhoneQuery"
      :model="editPhoneQuery"
      label-width="4rem"
    >
      <el-dialog
        custom-class="edit-phone-dialog"
        title="修改联系手机"
        :visible.sync="isEditPhoneShow"
        width="450px"
      >
        <div>
          <div class="tip-group flex-center">
            <div class="flex align-start">
              <div class="flex">
                <svg-icon icon-class="hint" class="icon-hint" />
                <span class="dot"></span>
              </div>
              <span class="tip"
                >您正在为 {{ userInfo.name }}（{{
                  userInfo.userName
                }}）变更关联手机，请输入该用户的新关联手机</span
              >
            </div>
          </div>
          <el-form-item label="手机" prop="phoneNumber">
            <div class="flex">
              <el-select v-model="editPhoneQuery.areaCode" placeholder="请选择">
                <el-option
                  v-for="item in areaCodeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                class="input-phone"
                clearable
                v-model="editPhoneQuery.phoneNumber"
                placeholder="请输入新手机号"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <!-- <div class="key">验证码</div> -->
            <div class="flex input-code-group">
              <el-input
                v-model="editPhoneQuery.code"
                placeholder="请输入验证码"
                class="input-code"
                clearable
              ></el-input>
              <div
                class="send flex-center"
                :class="{ disabled: messageCodeText != '发送验证码' }"
                @click="
                  messageCodeText == '发送验证码'
                    ? sendCode(editPhoneQuery.phoneNumber)
                    : ''
                "
              >
                {{ messageCodeText }}
              </div>
            </div>
          </el-form-item>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEditPhoneShow = false">取消</el-button>
          <el-button type="primary" @click="editPhone('editPhoneQuery')"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </el-form>
    <!-- 修改邮箱 -->
    <el-form
      v-if="isEditEmailShow"
      :rules="editEmailRules"
      ref="editEmailQuery"
      :model="editEmailQuery"
      label-width="3rem"
    >
      <el-dialog
        title="修改邮箱"
        custom-class="edit-phone-dialog"
        :visible.sync="isEditEmailShow"
        width="450px"
      >
        <div>
          <div class="tip-group flex-center">
            <div class="flex align-start">
              <div class="flex">
                <svg-icon icon-class="hint" class="icon-hint" />
                <span class="dot"></span>
              </div>
              <span class="tip"
                >您正在为
                {{
                  userInfo.name
                }}（HUI235648879920）变更关联邮箱，请输入该用户的新关联邮箱</span
              >
            </div>
          </div>
          <el-form-item label="邮箱" prop="email">
            <el-input
              class="input-email"
              v-model="editEmailQuery.email"
              placeholder="请输入邮箱"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEditEmailShow = false">取消</el-button>
          <el-button type="primary" @click="editEmail('editEmailQuery')"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </el-form>
    <!-- 解绑邮箱 -->
    <el-dialog
      custom-class="unbind-email-dialog"
      :visible.sync="isUnbindEmailShow"
      :show-close="false"
      width="420px"
      center
    >
      <div class="flex">
        <svg-icon icon-class="success" class="success" />
        <div>
          <div class="title">解绑成功</div>
          <div class="tip">
            您已成功解除与邮箱（）的绑定关系，后续您将无法用该方式登录当前账号。
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isUnbindEmailShow = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改密码 -->
    <el-form
      v-if="isEditPswShow"
      :rules="editPswRules"
      ref="editPswQuery"
      :model="editPswQuery"
      label-width="5rem"
    >
      <el-dialog
        title="修改密码"
        custom-class="edit-phone-dialog edit-pwd"
        :visible.sync="isEditPswShow"
        width="482px"
      >
        <div>
          <el-form-item label="原始密码" prop="currentPassword">
            <el-input
              type="password"
              class="input-email"
              v-model="editPswQuery.currentPassword"
              placeholder="请输入原始密码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              type="password"
              class="input-email"
              v-model="editPswQuery.newPassword"
              placeholder="请输入新密码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="repetPsw">
            <el-input
              type="password"
              class="input-email"
              v-model="editPswQuery.repetPsw"
              placeholder="请再次输入新密码"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码" prop="code">
            <div class="flex input-code-group">
              <el-input
                v-model="editPswQuery.code"
                placeholder="请输入手机验证码"
                class="input-code"
                clearable
              ></el-input>
              <div
                class="send flex-center"
                :class="{disabled:messageCodeText!='发送验证码'}"
                @click="messageCodeText=='发送验证码'?sendCode(userInfo.phoneNumber):''"
              >{{messageCodeText}}</div>
            </div>
          </el-form-item>-->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEditPswShow = false">取消</el-button>
          <el-button type="primary" @click="changePswSubmit('editPswQuery')"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </el-form>
    <!-- 身份验证 -->
    <el-dialog
      title="身份验证"
      custom-class="edit-phone-dialog authentication"
      :visible.sync="isAuthenticationShow"
      width="550px"
    >
      <div>
        <div class="tip-group flex tip-authentication">
          <span class="tip">为了您的账号安全，请用微信扫码验证身份。</span>
        </div>
        <img
          class="ercode"
          src="https://bkimg.cdn.bcebos.com/pic/2934349b033b5bb571dc8c5133d3d539b600bc12?x-bce-process=image/resize,m_lfit,w_268,limit_1/format,f_jpg"
          alt
        />
        <div class="info">
          <div class="name">需要(微信号：猫*鹰) 扫描验证身份</div>
          <div class="other">使用备选校验方式</div>
        </div>
      </div>
    </el-dialog>
    <!-- 修改个性签名 -->
    <el-form
      v-if="isEditMottoShow"
      ref="editMottoQuery"
      :model="editMottoQuery"
      label-width="5rem"
    >
      <el-dialog
        title="修改个性签名"
        custom-class="edit-phone-dialog"
        :visible.sync="isEditMottoShow"
        width="450px"
      >
        <div>
          <div class="tip-group flex-center">
            <div class="flex align-start">
              <div class="flex">
                <svg-icon icon-class="hint" class="icon-hint" />
                <span class="dot"></span>
              </div>
              <span class="tip"
                >您正在为
                {{
                  userInfo.name
                }}（HUI235648879920）变更个性签名，请输入该用户的个性签名</span
              >
            </div>
          </div>
          <el-form-item label="个性签名" prop="motto">
            <el-input
              class="input-motto"
              v-model="editMottoQuery.motto"
              placeholder="请输入个性签名"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEditMottoShow = false">取消</el-button>
          <el-button type="primary" @click="editMotto">确定</el-button>
        </span>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import indexJs from "./index.js";
export default {
  ...indexJs,
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
